const apis = [
  'setLocalCache', // 保存数据到本地缓存
  'getLocalCache', // 读取本地缓存数据
  'removeLocalCache', // 删除指定缓存数据
  'openWebView', // 新建webview
  'closeCurrentWebView', // 关闭当前webview
  'closeWebViews', // 关闭所有webview
  'setNavigationBar', // 设置导航栏
  'toast', // Toast组件
  'jumpToNativePage', // 去原生页面
  'hiddenCancelByStatus', // 作业传订单状态
  'showTakePhotoWindow', // 拍照弹窗
  'redPacketPopup', // 红包弹窗
  'launchMiniProgram', // 跳转小程序
  'startVoicePlayback', // 语音播放，开始
  'stopVoicePlayback', // 语音播放，停止
  'pausePlayVoiceback' // 暂停播放
];

const jsApi = {
  ready() {
    return new Promise((resolve, reject) => {
      // cb = cb || noop

      if (window.WebViewJavascriptBridge) {
        console.log('Api has been initialized.');
        return resolve();
      }

      // Android
      document.addEventListener(
        'WebViewJavascriptBridgeReady',
        function() {
          console.log('Api is initializing.');
          resolve();
        },
        false
      );

      // IOS
      const iosInitCallback = function() {
        console.log('Api is initializing.');
        resolve();
      };

      if (!window.WVJBCallbacks) {
        window.WVJBCallbacks = [];
      }

      window.WVJBCallbacks.push(iosInitCallback);
    });
  },

  // 调取api
  async call(apiName, params = {}) {
    await this.ready();
    return callNative(apiName, params);

    function callNative(name) {
      // 调用原生api

      return new Promise((resolve, reject) => {
        window.WebViewJavascriptBridge.callHandler(
          'invokeNative',
          {
            method: name,
            data: params
          },
          function(response) {
            if (typeof response === 'string') {
              try {
                response = JSON.parse(response);
              } catch (_) {
                //
              }
            }
            console.log('调用webview接口method：' + name + '内容：' + response);

            if (response.code === 0) {
              resolve(response);
            } else {
              // Toast(response.message || '调用webview接口出错')
              reject(response);
            }
          }
        );
      });
    }
  }
};

function registApis(apis) {
  for (const name of apis) {
    jsApi[name] = function(params) {
      return jsApi.call(name, params);
    };
  }
}

// 注册api
registApis(apis);

var WVJBIframe = document.createElement('iframe');
WVJBIframe.style.display = 'none';
WVJBIframe.src = 'https://__bridge_loaded__';
document.documentElement.appendChild(WVJBIframe);

setTimeout(function() {
  document.documentElement.removeChild(WVJBIframe);
}, 0);

jsApi.install = function(Vue) {
  if (Vue.prototype.$bridge) {
    return;
  }
  Vue.prototype.$bridge = jsApi;
};

export default jsApi;
